import React, { useState, useEffect } from 'react'
import { Accordion, useAccordionButton } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import './sidebar.css'
import logo1 from '../StudentRegristrationDesign/jain logo.png'

function Sidebar() {
  const [isOpen, setIsOpen] = useState(true)
  const [activeKey, setActiveKey] = useState(null)
  const location = useLocation()

  const navigate = useNavigate()

  useEffect(() => {
    let sessionData = sessionStorage.getItem('email')
    let flag = sessionStorage.getItem('flag')
    if (!sessionData || !flag) {
      navigate('/')
    }
  }, [])

  let flag = Number(sessionStorage.getItem('flag'))

  const CustomToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      setActiveKey(activeKey === eventKey ? null : eventKey)
    })

    return (
      <span
        onClick={decoratedOnClick}
        style={{
          color: '#ffffff',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {children}
      </span>
    )
  }

  useEffect(() => {
    // Set the active key based on the current path
    if (
      location.pathname.startsWith('/Block') ||
      location.pathname.startsWith('/room') ||
      location.pathname.startsWith('/Bed')
    ) {
      setActiveKey('2')
    } else if (
      location.pathname.startsWith('/FeeType') ||
      location.pathname.startsWith('/FeeMaster1')
    ) {
      setActiveKey('0')
    } else if (
      location.pathname.startsWith('/Reg50Approval') ||
      location.pathname.startsWith('/StudentView') ||
      location.pathname.startsWith('/RoomApproval') ||
      location.pathname.startsWith('/payment') ||
      location.pathname.startsWith('/JobApproval') ||
      location.pathname.startsWith('/RegularAndEventLeaveApprove') ||
      location.pathname.startsWith('/MessLeaveApprove') ||
      location.pathname.startsWith('/EventLeaveApprove')
    ) {
      setActiveKey('1')
    } else if (
      location.pathname.startsWith('/JobCategoryMaster') ||
      location.pathname.startsWith('/Jobpost') ||
      location.pathname.startsWith('/Alljob') ||
      location.pathname.startsWith('/payment')
    ) {
      setActiveKey('3')
    } else if (
      location.pathname.startsWith('/BoardingDirectorsImgMaster') ||
      location.pathname.startsWith('/WebsiteDashboardImgMaster') ||
      location.pathname.startsWith('/GalleryMaster')
    ) {
      setActiveKey('4')
    } else if (
      location.pathname.startsWith('/event') ||
      location.pathname.startsWith('/EventAttendance')
    ) {
      setActiveKey('5')
    } else if (
      location.pathname.startsWith('/RequestRec') ||
      location.pathname.startsWith('/MessLeaveApproval') ||
      location.pathname.startsWith('/MessAttendanceAdmin') ||
      location.pathname.startsWith('/FeedBack') ||
      location.pathname.startsWith('/BreakfastmenuMaster') ||
      location.pathname.startsWith('/MessMenuMaster')
    ) {
      setActiveKey('6')
    } else if (
      location.pathname.startsWith('/Discharge') ||
      location.pathname.startsWith('/Admin2Discharge') 
    ) {
      setActiveKey('7')
    }
  }, [location])

  useEffect(() => {
  setIsOpen(true)
}, [location.pathname])


  return (
    <div
      className={`sidebar ${isOpen ? 'open' : ''}`}
     style={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1',        
        height: '100vh',
        background: '#a2d6f8ff',
        color: '#fff',
        fontFamily: 'Poppins, sans-serif',
        transition: 'all 0.3s ease',
      }}
    >

       <div className="row logo-details text-center mb-5">
        <div
          className="logo_name"
          style={{
            color: '#0783d6ff',
            fontSize: '22px',
            fontWeight: 600,
            letterSpacing: '1px',
            margin: '0 auto',
          }}
        >
          <img
            src={logo1}
            alt="Logo"
            style={{ mixBlendMode: 'darken',height:"100px" }}
            // className="mb-3"
          />
        </div>
      </div>

      <div className="sidebar-content">
        <ul className="nav-list"  style={{ padding: '0 10px', }}>

{/* ======== Dashboard ========= */}
          {(flag == 1 || flag == 2 || flag == 3 || flag == 4) && (
            <li>
              <a
                href="/#/HomeAdmin"
                className="active"
                style={{ backgroundColor: 'transparent' }}
              >
                <i className="fa fa-line-chart"></i>
                {isOpen &&<span className="links_name">Dashboard</span>}
              </a>
              <span className="tooltip">Dashboard</span>
            </li>
          )}

{/* ======== Approvals ========= */}
          <Accordion activeKey={activeKey}>
            <li>
              {(flag == 1 || flag == 3 || flag == 2) && (
                <CustomToggle eventKey="1" className="master">
                  <i className="fa-solid fa-person-circle-check"></i>
                 {isOpen && <span className="links_name" style={{ color: 'black' }}>
                    Approvals
                  </span>}
                 {isOpen && <span
                    className="arrow-icon"
                    style={{ marginLeft: 'auto', color: 'black' }}
                  >
                    <>&#9660;</>
                  </span>}
                </CustomToggle>
              )}
              <Accordion.Collapse eventKey="1">
                <ul className="dropdown-list " style={{ listStyle: 'none' }}>
                  {(flag == 1 || flag == 3) && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/Reg50Approval"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i className="fa-solid fa-file"></i>
                        <span className="links_name">Application Approval</span>
                      </a>
                    </li>
                  )}

                    {(flag == 2) && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/AppApprovalList"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i className="fa-solid fa-user"></i>
                        <span className="links_name">Pending Application</span>
                      </a>
                    </li>
                  )}
                    {(flag == 3) && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/MemberAppPending"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i className="fa-solid fa-user"></i>
                        <span className="links_name">Pending Members</span>
                      </a>
                    </li>
                  )}

                  {(flag == 1 || flag == 2) && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/StudentView"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i className="fa-solid fa-user"></i>
                        <span className="links_name">Member Approval</span>
                      </a>
                    </li>
                  )}

                  {(flag == 1 || flag == 3) && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/payment"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <RiMoneyRupeeCircleFill  style={{fontSize:"27px",color:"black",marginLeft:"10px"}}/> &nbsp;&nbsp;&nbsp;
                        <span className="links_name">Payment Approval</span>
                      </a>
                    </li>
                  )}

                  {(flag == 1 || flag == 3) && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/JobApproval"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i className="fa-solid fa-bag-shopping"></i>
                        <span className="links_name">Job Approval</span>
                      </a>
                    </li>
                  )}

                  {(flag == 1 || flag == 2) && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/RegularAndEventLeaveApprove"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i class="fa-solid fa-newspaper"></i>
                        <span className="links_name">
                          Regular Leave Approval
                        </span>
                      </a>
                    </li>
                  )}

                  {(flag == 1 || flag == 2) && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/EventLeaveApprove"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i class="fa-solid fa-pager"></i>
                        <span className="links_name">Event Leave Approval</span>
                      </a>
                    </li>
                  )}

                  {flag == 1 && (
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/MessLeaveApprove"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i class="fa-solid fa-bowl-food"></i>
                        <span className="links_name">Mess Leave Approval</span>
                      </a>
                    </li>
                  )}
                </ul>
              </Accordion.Collapse>
            </li>
          </Accordion>

{/* ======== Menu List ========= */}
          {flag == 2 && (
            <li>
              <a
                className="ps-2 text-start"
                href="/#/MessMenuMaster"
                style={{
                  textDecoration: 'none',
                  backgroundColor: 'transparent',
                }}
              >
                <i class="fa-solid fa-plate-wheat"></i>
                {isOpen &&<span className="links_name">Menu List</span>}
              </a>
            </li>
          )}

{/* ========Main Admin Mess ========= */}
          {flag == 1 && (
            <Accordion activeKey={activeKey}>
              <li>
                <CustomToggle eventKey="6">
                  <i class="fa-solid fa-bowl-rice"></i>
                  {isOpen &&<span className="links_name" style={{ color: 'black' }}>
                    Mess
                  </span>}
                  {isOpen &&<span
                    className="arrow-icon"
                    style={{ marginLeft: 'auto', color: 'black' }}
                  >
                    <>&#9660;</>
                  </span>}
                </CustomToggle>
                <Accordion.Collapse eventKey="6">
                  <ul className="dropdown-list " style={{ listStyle: 'none' }}>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/MessMenuMaster"
                        style={{
                          textDecoration: 'none',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-plate-wheat"></i>
                        <span className="links_name">Menu Master</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/BreakfastmenuMaster"
                        style={{
                          textDecoration: 'none',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-hot-tub-person"></i>
                        <span className="links_name">BreakFast Master</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/MessAttendanceAdmin"
                        style={{
                          textDecoration: 'none',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-clipboard-user"></i>
                        <span className="links_name">Mess Attendance</span>
                      </a>
                    </li>


                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/RequestRec"
                        style={{
                          textDecoration: 'none',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-bell-concierge"></i>
                        <span className="links_name">Breakfast Request</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/FeedBack"
                        style={{
                          textDecoration: 'none',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-pager"></i>
                        <span className="links_name">Mess Feedback</span>
                      </a>
                    </li>
                  </ul>
                </Accordion.Collapse>
              </li>
            </Accordion>
          )}

{/* ======== Mess Admin========= */}
          {flag == 4 && (
            <>
              <li>
                <a
                  className="ps-2 text-start"
                  href="/#/MessAttendanceAdmin"
                  style={{
                    textDecoration: 'none',
                    backgroundColor: 'transparent',
                  }}
                >
                  <i class="fa-solid fa-clipboard-user"></i>
                  <span className="links_name">Attendance</span>
                </a>
              </li>
              <li>
                <a
                  className="ps-2 text-start"
                  href="/#/MessLeaveApproval"
                  style={{
                    textDecoration: 'none',
                    backgroundColor: 'transparent',
                  }}
                >
                  <i class="fa-solid fa-bowl-food"></i>
                  <span className="links_name">Mess Leave Approval</span>
                </a>
              </li>
              <li>
                <a
                  className="ps-2 text-start"
                  href="/#/RequestRec"
                  style={{
                    textDecoration: 'none',
                    backgroundColor: 'transparent',
                  }}
                >
                  <i class="fa-solid fa-bell-concierge"></i>
                  <span className="links_name">Breakfast Request</span>
                </a>
              </li>
              <li>
                <a
                  className="ps-2"
                  href="/#/event"
                  style={{
                    textDecoration: 'none',
                    // color: '#495494',
                    backgroundColor: 'transparent',
                  }}
                >
                  <i className="fa-solid fa-calendar-days"></i>
                  <span className="links_name">
                    {' '}
                    {flag === 4 ? 'Event List' : null}
                  </span>
                </a>
              </li>

                <li>
                <a
                  className="ps-2 text-start"
                  href="/#/MessMenuMaster"
                  style={{
                    textDecoration: 'none',
                    backgroundColor: 'transparent',
                  }}
                >
                  <i class="fa-solid fa-plate-wheat"></i>
                  <span className="links_name">Menu Master</span>
                </a>
                </li>
                <li>
                  <a
                    className="ps-2 text-start"
                    href="/#/BreakfastmenuMaster"
                    style={{
                      textDecoration: 'none',
                      backgroundColor: 'transparent',
                    }}
                  >
                    <i class="fa-solid fa-hot-tub-person"></i>
                    <span className="links_name">Breakfast Master</span>
                  </a>
                </li>

              <li>
                <a
                  className="ps-2 text-start"
                  href="/#/FeedBack"
                  style={{
                    textDecoration: 'none',
                    backgroundColor: 'transparent',
                  }}
                >
                  <i class="fa-solid fa-pager"></i>
                  <span className="links_name">Feedback</span>
                </a>
              </li>
            </>
          )}

{/* ======== Room Change ========= */}
          {(flag == 1 || flag == 2) && (
            <li>
              <a
                href="/#/RoomChange"
                style={{ backgroundColor: 'transparent' }}
              >
                <i class="fa-solid fa-house-user"></i>
                <span className="links_name">Room Change</span>
              </a>
            </li>
          )}

{/* ======== Complaints ========= */}
          {(flag == 1 || flag == 3 || flag == 2 || flag == 4) && (
            <li>
              <a href="/#/complaint" style={{ backgroundColor: 'transparent' }}>
                <i className="fa-solid fa-file-lines"></i>
                <span className="links_name">Complaints</span>
              </a>
            </li>
          )}

{/* ======== Event ========= */}
          <Accordion activeKey={activeKey}>
            <li>
              {(flag == 1 || flag == 3 || flag == 2) && (
                <CustomToggle eventKey="5">
                  <i className="fa-solid fa-calendar-days"></i>
                  {isOpen &&<span className="links_name" style={{ color: 'black' }}>
                    Event
                  </span>}
                  {isOpen &&<span
                    className="arrow-icon"
                    style={{ marginLeft: 'auto', color: 'black' }}
                  >
                    <>&#9660;</>
                  </span>}
                </CustomToggle>
              )}
              <Accordion.Collapse eventKey="5">
                <ul className="dropdown-list" style={{ listStyle: 'none' }}>
                  {(flag == 1 || flag == 3 || flag == 2) && (
                    <li>
                      <a
                        className="ps-2"
                        href="/#/event"
                        style={{
                          textDecoration: 'none',
                          // color: '#495494',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i className="fa-solid fa-calendar-days"></i>
                        <span className="links_name">
                          {' '}
                          {flag === 1
                            ? 'Add Events'
                            : flag === 2
                            ? 'Event List'
                            : flag === 3
                            ? 'Event List'
                            : flag === 4
                            ? 'Event List'
                            : null}
                        </span>
                      </a>
                    </li>
                  )}

                  {(flag == 1 || flag == 2) && (
                    <li>
                      <a
                        className="ps-2"
                        href="/#/EventAttendance"
                        style={{
                          textDecoration: 'none',
                          // color: '#495494',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-clipboard-user"></i>
                        <span className="links_name">Event Attendance</span>
                      </a>
                    </li>
                  )}
                </ul>
              </Accordion.Collapse>
            </li>
          </Accordion>

{/* ======== Jobs ========= */}
          <Accordion activeKey={activeKey}>
            <li>
              {(flag == 1 || flag == 3 || flag == 2) && (
                <CustomToggle eventKey="3">
                  <i class="fa-solid fa-user-doctor"></i>
                  {isOpen &&<span className="links_name" style={{ color: 'black' }}>
                    Jobs
                  </span>}
                  {isOpen &&<span
                    className="arrow-icon"
                    style={{ marginLeft: 'auto', color: 'black' }}
                  >
                    <>&#9660;</>
                  </span>}
                </CustomToggle>
              )}
              <Accordion.Collapse eventKey="3">
                <ul className="dropdown-list" style={{ listStyle: 'none' }}>
                  {(flag == 1 || flag == 3) && (
                    <li>
                      <a
                        className="ps-2"
                        href="/#/JobCategoryMaster"
                        style={{
                          textDecoration: 'none',
                          // color: '#495494',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i className="fa-solid fa-layer-group"></i>
                        <span className="links_name">Job Category Master</span>
                      </a>
                    </li>
                  )}

                  {(flag == 1 || flag == 3 || flag == 2) && (
                    <li>
                      <a
                        className="ps-2"
                        href="/#/JobpostAdmin"
                        style={{
                          textDecoration: 'none',
                          // color: '#495494',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i className="fa-solid fa-folder-plus"></i>
                        <span className="links_name">Job Post</span>
                      </a>
                    </li>
                  )}

                  {(flag == 1 || flag == 3 || flag == 2) && (
                    <li>
                      <a
                        className="ps-2"
                        href="/#/Alljob"
                        style={{
                          textDecoration: 'none',
                          // color: '#495494',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i className="fa-solid fa-list"></i>
                        <span className="links_name">All Job Data</span>
                      </a>
                    </li>
                  )}
                </ul>
              </Accordion.Collapse>
            </li>
          </Accordion>


{/* ======== TO DO ========= */}

          {flag == 1 && (
            <li>
              <a
                href="/#/ToDoMainAdmin"
                style={{ backgroundColor: 'transparent' }}
              >
                <i class="fa-solid fa-clipboard-list"></i>
                <span className="links_name">To Do</span>
              </a>
            </li>
          )}

{/* ======== Task To Do ========= */}
          {(flag == 2 || flag == 3 || flag == 4) && (
            <li>
              <a
                href="/#/ToDoAllAdmin"
                style={{ backgroundColor: 'transparent' }}
              >
                <i class="fa-solid fa-clipboard-list"></i>
                <span className="links_name">Task To Do</span>
              </a>
            </li>
          )}

{/* ======== Donation List ========= */}
          {(flag == 1 || flag == 3) && (
            <li>
              <a
                href="/#/DonationList"
                style={{ backgroundColor: 'transparent' }}
              >
                <i class="fa-solid fa-hand-holding-dollar"></i>
                <span className="links_name">Donation List</span>
              </a>
            </li>
          )}

{/* ======== Alumini List ========= */}
          {(flag == 1 || flag == 3 || flag == 2) && (
            <li>
              <a
                href="/#/AluminiList"
                style={{ backgroundColor: 'transparent' }}
              >
                <i class="fa-solid fa-users"></i>
                <span className="links_name">Alumni List</span>
              </a>
            </li>
          )}

{/* ======== Suggestions ========= */}
          {(flag == 1 || flag == 3 || flag == 2) && (
            <li>
              <a
                href="/#/SuggestionAll"
                style={{ backgroundColor: 'transparent' }}
              >
                <i class="fa-regular fa-file"></i>
                <span className="links_name">Suggestions</span>
              </a>
            </li>
          )}

{/* ========All Reports ========= */}
          {(flag == 1 || flag == 3 || flag == 2) && (
            <li>
              <a
                href="/#/AdminDashboardReport"
                style={{ backgroundColor: 'transparent' }}
              >
                <i class="fa-solid fa-border-all"></i>
                <span className="links_name">Reports</span>
              </a>
            </li>
          )}

{/* ========Mess Report ========= */}
            {(flag == 4) && (
            <li>
              <a
                href="/#/MessWiseAttendance"
                style={{ backgroundColor: 'transparent' }}
              >
                <i class="fa-solid fa-border-all"></i>
                <span className="links_name">Reports</span>
              </a>
            </li>
          )}

{/* ======== Discharge ========= */}
        {(flag == 1 || flag == 2 || flag == 3) && (
              <Accordion activeKey={activeKey}>
                <li>
                    <CustomToggle eventKey="7">
                      <i class="fa-solid fa-eject"></i>
                     {isOpen && <span className="links_name" style={{ color: 'black' }}>
                        Discharge
                      </span>}
                      {isOpen &&<span
                        className="arrow-icon"
                        style={{ marginLeft: 'auto', color: 'black' }}
                      >
                        <>&#9660;</>
                      </span>}
                    </CustomToggle>
                  <Accordion.Collapse eventKey="7">
                    <ul className="dropdown-list" style={{ listStyle: 'none' }}>
                      {(flag == 1 || flag == 2) && (
                          <li>
                            <a href="/#/Discharge" style={{ backgroundColor: 'transparent' }}>                          
                              <i class="fa-solid fa-user"></i>
                              <span className="links_name">Discharge(Superi.)</span>
                            </a>
                          </li>
                        )}

                        {(flag == 1 || flag == 3) && (
                          <li>
                            <a
                              href="/#/Admin2Discharge"
                              style={{ backgroundColor: 'transparent' }}
                            >
                              <i class="fa-solid fa-user"></i>
                              <span className="links_name">Discharge(Office Att.) </span>
                            </a>
                          </li>
                        )}
                    </ul>
                  </Accordion.Collapse>
                </li>
              </Accordion>                  
          )}


{/* ======== Admission Rule Master ========= */}
          {(flag == 1 || flag == 3) && (
            <li>
              <a href="/#/Rule" style={{ backgroundColor: 'transparent' }}>
                <i className="fa-solid fa-comments"></i>
                <span className="links_name">Admission Rule Master</span>
              </a>
              <span className="tooltip">Admission Rules</span>
            </li>
          )}

{/* ======== Highlight Master ========= */}
          {(flag == 1 || flag == 3) && (
            <li>
              <a href="/#/Highlight" style={{ backgroundColor: 'transparent' }}>
                <i class="fa-regular fa-snowflake"></i>
                <span className="links_name">Highlight Master</span>
              </a>
              <span className="tooltip">Highlight Master</span>
            </li>
          )}

{/* ======== Fee Master ========= */}
          {(flag == 1 || flag == 3) && (
            <Accordion activeKey={activeKey}>
              <li>
                <CustomToggle eventKey="0">
                  <i className="fa-solid fa-sack-dollar"></i>
                  {isOpen &&<span className="links_name" style={{ color: 'black' }}>
                    Fee Master
                  </span>}
                  {isOpen &&<span
                    className="arrow-icon"
                    style={{ marginLeft: 'auto', color: 'black' }}
                  >
                    <>&#9660;</>
                  </span>}
                </CustomToggle>
                <Accordion.Collapse eventKey="0">
                  <ul className="dropdown-list " style={{ listStyle: 'none' }}>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/FeeType"
                        style={{
                          textDecoration: 'none',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i className="fa-solid fa-indian-rupee-sign"></i>
                        <span className="links_name">Fee Type Master</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/FeeMaster1"
                        style={{
                          textDecoration: 'none',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-rupee-sign"></i>
                        <span className="links_name">Fees Amount Entry</span>
                      </a>
                    </li>
                  </ul>
                </Accordion.Collapse>
              </li>
            </Accordion>
          )}

{/* ======== Room Master ========= */}
          {(flag == 1 || flag == 3) && (
            <Accordion activeKey={activeKey}>
              <li>
                <CustomToggle eventKey="2" className="master">
                  <i class="fa-solid fa-house-medical"></i>
                  {isOpen &&<span className="links_name" style={{ color: 'black' }}>
                    Room Master
                  </span>}
                  {isOpen &&<span
                    className="arrow-icon"
                    style={{ marginLeft: 'auto', color: 'black' }}
                  >
                    <>&#9660;</>
                  </span>}
                </CustomToggle>
                <Accordion.Collapse eventKey="2">
                  <ul className="dropdown-list" style={{ listStyle: 'none' }}>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/Block"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i className="fa-solid fa-building"></i>
                        <span className="links_name">Block</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/room"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i className="fa-solid fa-house-user"></i>
                        <span className="links_name">Room</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="ps-2 text-start"
                        href="/#/Bed"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <i className="fa-solid fa-bed"></i>
                        <span className="links_name">Bed</span>
                      </a>
                    </li>
                  </ul>
                </Accordion.Collapse>
              </li>
            </Accordion>
          )}

          {/* ======== Gallery (Website Dashboard Img)========= */}
          {(flag == 1 || flag == 3) && (
            <Accordion activeKey={activeKey}>
              <li>
                <CustomToggle eventKey="4">
                  <i className="fa-solid fa-image"></i>
                  {isOpen &&<span className="links_name" style={{ color: 'black' }}>
                    Gallery Master
                  </span>}
                  {isOpen &&<span
                    className="arrow-icon"
                    style={{ marginLeft: 'auto', color: 'black' }}
                  >
                    <>&#9660;</>
                  </span>
                  }
                </CustomToggle>
                <Accordion.Collapse eventKey="4">
                  <ul className="dropdown-list" style={{ listStyle: 'none' }}>
                    <li>
                      <a
                        className="ps-2"
                        href="/#/WebsiteDashboardImgMaster"
                        style={{
                          textDecoration: 'none',
                          // color: '#495494',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i className="fa-solid fa-layer-group"></i>
                        <span className="links_name">Website Dashboard</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="ps-2"
                        href="/#/BoardingDirectorsImgMaster"
                        style={{
                          textDecoration: 'none',
                          // color: '#495494',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-user"></i>
                        <span className="links_name">Boarding Director </span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="ps-2"
                        href="/#/GalleryMaster"
                        style={{
                          textDecoration: 'none',
                          // color: '#495494',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <i class="fa-solid fa-image"></i>
                        <span className="links_name">Gallery Master</span>
                      </a>
                    </li>
                  </ul>
                </Accordion.Collapse>
              </li>
            </Accordion>
          )}

{/* ======== Gallery Master ========= */}
          {flag == 2 && (
            <li>
              <a
                className="ps-2"
                href="/#/GalleryMaster"
                style={{
                  textDecoration: 'none',
                  // color: '#495494',
                  backgroundColor: 'transparent',
                }}
              >
                <i class="fa-solid fa-image"></i>
                <span className="links_name">Gallery Master</span>
              </a>
            </li>
          )}

         
        </ul>
      </div>

    </div>
  )
}

export default Sidebar

